import React from "react";
import axios from "axios";
import {isMobileOnly} from "react-device-detect";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import {API_CONFIG} from '../../config/api_config';
import DoubleTemplateComponent from "../../containers/template_page/double_template_component/double_template_component";
import './c75_convenzioni_a.scss';

// /* Content of the Discount dropdown */
const optionsDiscount = [
    {value: 'All', label: 'All'},
    {value: '5', label: '5%'},
    {value: '10', label: '10%'},
    {value: '15', label: '15%'},
    {value: '20', label: '20%'},
    {value: '25', label: '25%'}
];

class ConvenzioniA extends DoubleTemplateComponent {
    uuid = '';
    date = '';
    discount = '';

    constructor(props) {
        super(props);
        this.state = {
            optionsCategory: [],
            arrayCallCat: [],
            searchTerm: '',
            filterCategory: '',
            filterMinDiscount: ''
        };
        this.requireInternationalization = true;
    }

    componentDidMount() {
        super.componentDidMount();
        this.loadTaxonomy();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        super.componentDidUpdate(prevProps, prevState, snapshot);
        if (this.props.language !== prevProps.language) {
            this.loadTaxonomy();
        }
    }

    loadTaxonomy() {
        // create select options before render html elements
        const epCategory = `${API_CONFIG.BASE_URL}/terms/${this.props.language}/convenzioni`;
        axios.get(epCategory).then(res => {

            let terms = res.data.terms;
            terms.sort(function(a, b){
                if(a.label < b.label) { return -1; }
                if(a.label > b.label) { return 1; }
                return 0;
            })
            this.setState({
                optionsCategory: terms.map(el => el.label),
                arrayCallCat: terms
            });
            this.state.optionsCategory.unshift('All');
        });
    }

    showMore = (ep) => {

        if (this.state.filterCategory !== '') {
            ep = ep + '&category=' + this.state.filterCategory;
        }
        if (this.state.filterMinDiscount !== '') {
            ep = ep + '&mindiscount=' + this.state.filterMinDiscount;
        }

        axios.get(ep, {}).then((res) => {
            let cards = this.state.data.conventions.concat(res.data.conventions);

            this.setState({
                callMore: true,
                data: {
                    ...this.state.data,
                    ...{conventions: cards, next_page: res.data.next_page},
                },
            });
        });

    };


    callFilter = () => {

        let params = {};
        params['views'] = true;
        params['limit'] = 9;

        let category = this.uuid;
        if (category) {
            params['category'] = category;
            this.setState({
                filterCategory: category
            })
            /**
             * Exmple that fetch one category when selecting a filter
             * params['category'] = '2726a016-55b6-404f-8518-82f53ec53b7b';
             */
        } else {
            this.setState({
                filterCategory: ''
            })
        }

        /**
         * if the min_discount is null in the be then the response will not contain the specific card,
         * therefor we cannot render it in the front end
         */
        let discount = this.discount;
        if (discount) {
            params['mindiscount'] = parseInt(discount);
            this.setState({
                filterMinDiscount: parseInt(discount)
            })
        } else {
            this.setState({
                filterMinDiscount: ''
            })
        }

        if (document.forms.searchForm && document.forms.searchForm.search && document.forms.searchForm.search.value) {
            params['search'] = document.forms.searchForm.search.value;
        }
        axios.get(this.state.data.__data, {params: params}).then(res => {
            this.setState({
                data: {...this.state.data, ...res.data},
                searchTerm: res.data.title
            });
        });
    };

    changeCategory = selected => {
        selected = selected.value;
        this.getValCat(selected);
        if (selected === 'All') {
            selected = '';
            this.uuid = '';
            this.callFilter();
        }

        // for each category in arrayCallCat find uuid based on selected value of category name
        this.state.arrayCallCat.forEach((filterString) => {
            for (var key in filterString) {
                if (filterString[key] === selected) {
                    this.uuid = filterString.id;
                    return this.callFilter();
                }
            }
        })
    };

    changeDiscount = selected => {
        selected = selected.value;
        this.getValDiscount(selected);
        if (selected === 'All') {
            selected = ''
        }
        this.discount = selected;
        this.callFilter();
    };

    getValCat = val => {
        this.setState({valueCat: val});
    };
    getValDiscount = val => {
        this.setState({valueDiscount: val});
    };

    internationalComponentRender(allData, t) {

        let filteredCards = allData.conventions;
        const {valueCat, valueDiscount} = this.state;

        return (
            <div id={!isMobileOnly ? "a-convenzioni-grid" : "a-convenzioni-grid-mob"} className="c52-news">
                <div className="container container-search-fields">
                    <div className="row">
                        <Dropdown
                            options={this.state.optionsCategory}
                            onChange={this.changeCategory}
                            value={valueCat}
                            placeholder={t("C75 Category filter")}
                            className={!isMobileOnly ? 'dropdown-categories col-4' : 'dropdown-categories'}
                        />
                        <Dropdown
                            options={optionsDiscount}
                            onChange={this.changeDiscount}
                            value={valueDiscount}
                            placeholder={t("C75 Discount filter")}
                            className={!isMobileOnly ? 'dropdown-categories col-4' : 'dropdown-categories'}
                        />
                    </div>
                </div>
                <div className="container">
                    <div className="row a-convenzioni-card-row">
                        {filteredCards && filteredCards.length > 0 ? (
                            filteredCards.map((card, index) => {
                                    let min_discount;
                                    let max_discount;

                                    if (!card.min_discount) {
                                        min_discount = card.max_discount;
                                        max_discount = false;
                                    } else {
                                        min_discount = card.min_discount;
                                        max_discount = card.max_discount;
                                    }

                                    return (
                                        <div className="col-xl-4 col-md-6" key={index}>
                                            <a href={card.url_card}>
                                                <div className="a-convenzioni-card mx-auto">
                                                    <div className="separator"/>
                                                    {card.category ? <div className="a-convenzioni-card-category">{card.category.label}</div> : null}
                                                    <div className="a-convenzioni-card-sconto">{card.max_discount || card.min_discount ?
                                                        <div>{t("C75 Discount label")} : {min_discount}% {max_discount ? `- ${max_discount}%` : null}</div> : null}</div>

                                                    <div className="a-convenzioni-card-title">{card.title && card.title}</div>
                                                </div>
                                            </a>
                                        </div>
                                    )
                                }
                            )) : (
                            <p className={"not-found"}>{t("C75 no content")}</p>
                        )}
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-12 text-center">
                                {allData.next_page !== "" && filteredCards && filteredCards.length > 0 && (
                                    <button className="a-convenzioni-carica-altro-btn" onClick={() => this.showMore(allData.next_page)}>{allData.loadmore_label}</button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ConvenzioniA;
